import styled from "styled-components";
import { ExButton } from "../../components/ExButton";
import { Pause, Play } from "lucide-react";
import { Modal } from "../../components/Modal";
import { ExSwitch } from "../../components/ExSwitch";
import { FormControlLabel, FormGroup } from "@mui/material";

export const FloatingButtonContainer = styled.div`
    position: fixed;
    bottom: 32px;
    right: 32px;
    z-index: 1000;
`;

export const ButtonAutoScroll = ({ autoScroll, setAutoScroll, setShowTabSelector }: {
    autoScroll: boolean;
    setAutoScroll: React.Dispatch<React.SetStateAction<boolean>>;
    setShowTabSelector: React.Dispatch<React.SetStateAction<boolean>>;
}) => (
    <FloatingButtonContainer>
        <ExButton
            iconcenter={autoScroll ? <Pause size={24} /> : <Play size={24} />}
            style={{
                borderRadius: 50,
                minWidth: 50,
                minHeight: 50,
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 5px rgba(0,0,0,0.3)",
            }}
            onClick={() => {
                if (!autoScroll) setShowTabSelector(true);
                else setAutoScroll(false);
            }}
        />
    </FloatingButtonContainer>
);

interface TabOption {
    key: string;
    label: string;
}

export const TabAutoScrollSelector = ({ show, onHide, onConfirm, scrollTabs, setScrollTabs, auth }: {
    show: boolean;
    onHide: () => void;
    onConfirm: () => void;
    scrollTabs: string[];
    setScrollTabs: React.Dispatch<React.SetStateAction<string[]>>;
    auth: any;
}) => {
    const tabOptions: TabOption[] = [
        ...(auth.useAppEstoques ? [
            { key: "entradas", label: "Entradas" },
            { key: "classificacao", label: "Classificação" },
            { key: "vendas", label: "Vendas" },
            { key: "transformacao", label: "Debulha" },
            { key: "plantio", label: "Plantio" },
            { key: "financeirogeral", label: "Financeiro Geral" },
        ] : []),
        ...(auth.useAppRequisicoes ? [
            { key: "requisicoes", label: "Requisições" },
        ] : []),
        ...(auth.useAppDP ? [
            { key: "colaboradores", label: "Colaboradores" },
        ] : []),
    ];

    const toggleTab = (key: string) => {
        setScrollTabs((prev) => prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]);
    };

    return (
        <Modal
            show={show}
            title="Selecionar abas para rotação automática"
            onHide={onHide}
            success={onConfirm}
            cancel={onHide}
        >
            <FormGroup sx={{ gap: '8px', padding: '0px 12px' }}>
                {tabOptions.map((tab) => (
                    <FormControlLabel
                        control={
                            <ExSwitch
                                key={tab.key}
                                checked={scrollTabs.includes(tab.key)}
                                onChange={() => toggleTab(tab.key)}
                                sx={{ marginRight: '8px' }}
                            />
                        }
                        label={" " + tab.label}
                    />
                ))}
            </FormGroup>
        </Modal>
    );
};
